import React, { Component } from 'react'
import * as R from 'ramda'
import { mapProps } from 'recompose'

import MultiHexInput from 'components/form/multiHexInput/index'
import {
  withConnect,
  withReducer,
  getValuesSelector,
  UPDATE_VALUE
} from 'containers/Form/MultiInput/index'
import { withValidationSagas } from 'containers/Form/Util/Validation/hex'
import {
  withValidation,
} from 'containers/Form/Validation/index'
import withValueObserver from 'containers/Form/Util/Validation/valueSaga'
import { isHexId } from 'containers/Form/Util/Validation/predicates'

export { default as MultiHexInput } from 'components/form/multiHexInput/index'
export {
  withConnect,
  withReducer
}

export default R.curry((path, id) => R.compose(
  mapProps((props) => ({ ...props, rules: isHexId })),
  withReducer(path, id),
  withConnect(path, id),
  withValidation(id),
  withValidationSagas(path, id, getValuesSelector(path, id)),
  withValueObserver(path, id, UPDATE_VALUE)
)(MultiHexInput))
